import {
  CARE_PLAN_ACTIVITIES_AT_A_GLANCE,
  INSTRUMENTAL_ACTIVITY_OPTIONS,
} from "../../../constants/constants";
import {
  buildCarePlanGeniePreview,
  CarePlanGenieFieldDefinition,
  CarePlanGenieQuestion,
} from "./carePlanGenieShared";

export interface InstrumentalActivitiesGenieSectionValues {
  [key: string]: any;
}

const activitiesAtGlanceValues = CARE_PLAN_ACTIVITIES_AT_A_GLANCE.map((option) => option.value);

export const IADL_GENIE_FIELD_DEFINITIONS: Record<string, CarePlanGenieFieldDefinition> = {
  manageFinanceLevel: { key: "manageFinanceLevel", label: "Finance level", type: "choice", applyMode: "replace" },
  manageFinanceDetails: { key: "manageFinanceDetails", label: "Finance details", type: "text", applyMode: "append" },
  manageFinanceAssistanceRequired: { key: "manageFinanceAssistanceRequired", label: "Finance assistance required", type: "text", applyMode: "append" },
  anyWhoManagesFinance: { key: "anyWhoManagesFinance", label: "Any who manages finance", type: "boolean", applyMode: "replace" },
  anyWhoManagesFinanceDetails: { key: "anyWhoManagesFinanceDetails", label: "Who manages finance details", type: "text", applyMode: "append" },
  anyWhoManagesFinanceAssistanceRequired: { key: "anyWhoManagesFinanceAssistanceRequired", label: "Who manages finance assistance required", type: "text", applyMode: "append" },
  anyWhoManagesFinancialRecords: { key: "anyWhoManagesFinancialRecords", label: "Any who manages financial records", type: "boolean", applyMode: "replace" },
  anyWhoManagesFinancialRecordsDetails: { key: "anyWhoManagesFinancialRecordsDetails", label: "Who manages financial records details", type: "text", applyMode: "append" },
  anyWhoManagesFinancialRecordsAssistanceRequired: { key: "anyWhoManagesFinancialRecordsAssistanceRequired", label: "Who manages financial records assistance required", type: "text", applyMode: "append" },
  anyPayeeDetails: { key: "anyPayeeDetails", label: "Any payee details", type: "boolean", applyMode: "replace" },
  payeeDetails: { key: "payeeDetails", label: "Payee details", type: "text", applyMode: "append" },

  manageShoppingLevel: { key: "manageShoppingLevel", label: "Shopping level", type: "choice", applyMode: "replace" },
  manageShoppingDetails: { key: "manageShoppingDetails", label: "Shopping details", type: "text", applyMode: "append" },
  manageShoppingAssistanceRequired: { key: "manageShoppingAssistanceRequired", label: "Shopping assistance required", type: "text", applyMode: "append" },
  specialShoppingTransportationNeeds: { key: "specialShoppingTransportationNeeds", label: "Special shopping transportation needs", type: "boolean", applyMode: "replace" },
  specialShoppingTransportationDetails: { key: "specialShoppingTransportationDetails", label: "Special shopping transportation details", type: "text", applyMode: "append" },
  specialShoppingTransportationAssistanceRequired: { key: "specialShoppingTransportationAssistanceRequired", label: "Special shopping transportation assistance required", type: "text", applyMode: "append" },
  shoppingFrequencyDetails: { key: "shoppingFrequencyDetails", label: "Shopping frequency details", type: "text", applyMode: "append" },
  shoppingFrequencyAssistanceRequired: { key: "shoppingFrequencyAssistanceRequired", label: "Shopping frequency assistance required", type: "text", applyMode: "append" },
  anyShoppingEquipmentNeeds: { key: "anyShoppingEquipmentNeeds", label: "Any shopping equipment needs", type: "boolean", applyMode: "replace" },
  shoppingEquipmentDetails: { key: "shoppingEquipmentDetails", label: "Shopping equipment details", type: "text", applyMode: "append" },
  shoppingEquipmentAssistanceRequired: { key: "shoppingEquipmentAssistanceRequired", label: "Shopping equipment assistance required", type: "text", applyMode: "append" },
  anyShoppingLimitations: { key: "anyShoppingLimitations", label: "Any shopping limitations", type: "boolean", applyMode: "replace" },
  shoppingLimitationsDetails: { key: "shoppingLimitationsDetails", label: "Shopping limitations details", type: "text", applyMode: "append" },
  shoppingLimitationsAssistanceRequired: { key: "shoppingLimitationsAssistanceRequired", label: "Shopping limitations assistance required", type: "text", applyMode: "append" },

  transportationManageLevel: { key: "transportationManageLevel", label: "Transportation level", type: "choice", applyMode: "replace" },
  transportationManageDetails: { key: "transportationManageDetails", label: "Transportation details", type: "text", applyMode: "append" },
  transportationManageAssistanceRequired: { key: "transportationManageAssistanceRequired", label: "Transportation assistance required", type: "text", applyMode: "append" },
  specialTransportationNeeds: { key: "specialTransportationNeeds", label: "Special transportation needs", type: "boolean", applyMode: "replace" },
  specialTransportationDetails: { key: "specialTransportationDetails", label: "Special transportation details", type: "text", applyMode: "append" },
  specialTransportationAssistanceRequired: { key: "specialTransportationAssistanceRequired", label: "Special transportation assistance required", type: "text", applyMode: "append" },
  anyTransportationMedicalNeeds: { key: "anyTransportationMedicalNeeds", label: "Any transportation medical needs", type: "boolean", applyMode: "replace" },
  transportationMedicalDetails: { key: "transportationMedicalDetails", label: "Transportation medical details", type: "text", applyMode: "append" },
  transportationMedicalAssistanceRequired: { key: "transportationMedicalAssistanceRequired", label: "Transportation medical assistance required", type: "text", applyMode: "append" },
  anyTransportationEscortNeeds: { key: "anyTransportationEscortNeeds", label: "Any transportation escort needs", type: "boolean", applyMode: "replace" },
  transportationEscortDetails: { key: "transportationEscortDetails", label: "Transportation escort details", type: "text", applyMode: "append" },
  transportationEscortAssistanceRequired: { key: "transportationEscortAssistanceRequired", label: "Transportation escort assistance required", type: "text", applyMode: "append" },
  anyTransportationEquipmentNeeds: { key: "anyTransportationEquipmentNeeds", label: "Any transportation equipment needs", type: "boolean", applyMode: "replace" },
  transportationEquipmentDetails: { key: "transportationEquipmentDetails", label: "Transportation equipment details", type: "text", applyMode: "append" },
  transportationEquipmentAssistanceRequired: { key: "transportationEquipmentAssistanceRequired", label: "Transportation equipment assistance required", type: "text", applyMode: "append" },
  anyTransportationLimitations: { key: "anyTransportationLimitations", label: "Any transportation limitations", type: "boolean", applyMode: "replace" },
  transportationLimitationsDetails: { key: "transportationLimitationsDetails", label: "Transportation limitations details", type: "text", applyMode: "append" },
  transportationLimitationsAssistanceRequired: { key: "transportationLimitationsAssistanceRequired", label: "Transportation limitations assistance required", type: "text", applyMode: "append" },

  activityLevel: { key: "activityLevel", label: "Activity level", type: "choice", applyMode: "replace" },
  activityDetails: { key: "activityDetails", label: "Activity details", type: "text", applyMode: "append" },
  activityAssistanceRequired: { key: "activityAssistanceRequired", label: "Activity assistance required", type: "text", applyMode: "append" },
  anyReligiousActivities: { key: "anyReligiousActivities", label: "Any religious activities", type: "boolean", applyMode: "replace" },
  religiousActivitiesDetails: { key: "religiousActivitiesDetails", label: "Religious activities details", type: "text", applyMode: "append" },
  religiousActivitiesAssistanceRequired: { key: "religiousActivitiesAssistanceRequired", label: "Religious activities assistance required", type: "text", applyMode: "append" },
  anySocialCulturalActivities: { key: "anySocialCulturalActivities", label: "Any social cultural activities", type: "boolean", applyMode: "replace" },
  socialCulturalActivitiesDetails: { key: "socialCulturalActivitiesDetails", label: "Social cultural activities details", type: "text", applyMode: "append" },
  socialCulturalActivitiesAssistanceRequired: { key: "socialCulturalActivitiesAssistanceRequired", label: "Social cultural activities assistance required", type: "text", applyMode: "append" },
  anyFamilyFriendsRelationships: { key: "anyFamilyFriendsRelationships", label: "Any family friends relationships", type: "boolean", applyMode: "replace" },
  familyFriendsRelationshipsDetails: { key: "familyFriendsRelationshipsDetails", label: "Family friends relationships details", type: "text", applyMode: "append" },
  familyFriendsRelationshipsAssistanceRequired: { key: "familyFriendsRelationshipsAssistanceRequired", label: "Family friends relationships assistance required", type: "text", applyMode: "append" },
  anyParticipationIssues: { key: "anyParticipationIssues", label: "Any participation issues", type: "boolean", applyMode: "replace" },
  participationIssuesDetails: { key: "participationIssuesDetails", label: "Participation issues details", type: "text", applyMode: "append" },
  participationIssuesAssistanceRequired: { key: "participationIssuesAssistanceRequired", label: "Participation issues assistance required", type: "text", applyMode: "append" },
  activitiesAtGlance: { key: "activitiesAtGlance", label: "Activities at a glance", type: "stringArray", applyMode: "mergeArray" },
  activityNarrative: { key: "activityNarrative", label: "Activity narrative", type: "text", applyMode: "append" },

  doesSmoke: { key: "doesSmoke", label: "Does smoke", type: "boolean", applyMode: "replace" },
  smokingDetails: { key: "smokingDetails", label: "Smoking details", type: "text", applyMode: "append" },
  smokingAssistanceRequired: { key: "smokingAssistanceRequired", label: "Smoking assistance required", type: "text", applyMode: "append" },
  anySmokingSafetyConcerns: { key: "anySmokingSafetyConcerns", label: "Any smoking safety concerns", type: "boolean", applyMode: "replace" },
  smokingSafetyConcernsDetails: { key: "smokingSafetyConcernsDetails", label: "Smoking safety concerns details", type: "text", applyMode: "append" },
  smokingSafetyConcernsAssistanceRequired: { key: "smokingSafetyConcernsAssistanceRequired", label: "Smoking safety concerns assistance required", type: "text", applyMode: "append" },
  anySmokingPolicySigned: { key: "anySmokingPolicySigned", label: "Any smoking policy signed", type: "boolean", applyMode: "replace" },
  smokingPolicySignedDetails: { key: "smokingPolicySignedDetails", label: "Smoking policy signed details", type: "text", applyMode: "append" },
  smokingStorageDetails: { key: "smokingStorageDetails", label: "Smoking storage details", type: "text", applyMode: "append" },

  receivesCaseManagement: { key: "receivesCaseManagement", label: "Receives case management", type: "boolean", applyMode: "replace" },
  caseManagementDetails: { key: "caseManagementDetails", label: "Case management details", type: "text", applyMode: "append" },
  caseManagementAssistanceRequired: { key: "caseManagementAssistanceRequired", label: "Case management assistance required", type: "text", applyMode: "append" },
  conditionsWhenToContactCaseManager: { key: "conditionsWhenToContactCaseManager", label: "Conditions when to contact case manager", type: "text", applyMode: "append" },
  caseManagerContactName: { key: "caseManagerContactName", label: "Case manager contact name", type: "text", applyMode: "replace" },
  caseManagerContactAgency: { key: "caseManagerContactAgency", label: "Case manager contact agency", type: "text", applyMode: "replace" },
  caseManagerContactPhone: { key: "caseManagerContactPhone", label: "Case manager contact phone", type: "text", applyMode: "replace" },

  additionalInformation: { key: "additionalInformation", label: "Additional information", type: "text", applyMode: "append" },
  additionalInformationAssistanceRequired: { key: "additionalInformationAssistanceRequired", label: "Additional information assistance required", type: "text", applyMode: "append" },
};

const iadlLevelQuestion = (
  id: string,
  title: string,
  prompt: string,
  levelField: string,
  detailField: string,
  assistanceField: string,
  detailContext: string,
  interventionContext: string,
): CarePlanGenieQuestion => ({
  id,
  title,
  prompt,
  helperText: "Choose the level that fits best, then add caregiver interventions that should happen consistently.",
  editableFieldKeys: [detailField, assistanceField],
  options: [
    {
      id: `${id}_independent`,
      label: "Independent",
      description: "Resident usually manages this area without caregiver help.",
      groupLabel: "IADL details",
      updates: {
        [levelField]: INSTRUMENTAL_ACTIVITY_OPTIONS[0],
        [detailField]: `Resident is generally independent with ${detailContext} and can usually complete the task without caregiver support.`,
      },
    },
    {
      id: `${id}_assistance`,
      label: "Needs assistance or setup",
      description: "Cueing, reminders, setup, or some direct support is needed.",
      groupLabel: "IADL details",
      updates: {
        [levelField]: INSTRUMENTAL_ACTIVITY_OPTIONS[1],
        [detailField]: `Resident needs assistance, cueing, setup, or oversight for ${detailContext} and may not complete the task consistently without support.`,
      },
    },
    {
      id: `${id}_limited`,
      label: "Limited or extensive help",
      description: "The resident depends on substantial caregiver involvement.",
      groupLabel: "IADL details",
      updates: {
        [levelField]: INSTRUMENTAL_ACTIVITY_OPTIONS[2],
        [detailField]: `Resident has limited ability with ${detailContext} and often depends on caregiver or another support person for major parts of the task.`,
      },
    },
    {
      id: `${id}_total`,
      label: "Total dependence",
      description: "Another person fully manages this area.",
      groupLabel: "IADL details",
      updates: {
        [levelField]: INSTRUMENTAL_ACTIVITY_OPTIONS[6],
        [detailField]: `Resident is dependent on others for ${detailContext} and does not independently manage this area safely or consistently.`,
      },
    },
    {
      id: `${id}_intervention_consistent`,
      label: "Use a consistent support routine",
      description: "Caregivers should follow the same approach every time.",
      groupLabel: "Caregiver interventions",
      updates: {
        [assistanceField]: `Caregivers should use a consistent approach for ${interventionContext}, provide reminders or hands-on help as needed, and adjust support based on the resident's daily condition.`,
      },
    },
    {
      id: `${id}_intervention_monitor`,
      label: "Monitor safety, follow-through, and changes",
      description: "Use when the resident's ability varies or needs oversight.",
      groupLabel: "Caregiver interventions",
      updates: {
        [assistanceField]: `Caregivers should monitor safety, follow-through, and changes related to ${interventionContext}, and communicate concerns to the care team when support needs increase.`,
      },
    },
    {
      id: `${id}_intervention_prepare`,
      label: "Plan ahead and set up the task clearly",
      description: "Helpful when routine, timing, or preparation improves follow-through.",
      groupLabel: "Caregiver interventions",
      updates: {
        [assistanceField]: `Caregivers should plan ahead for ${interventionContext}, prepare what is needed in advance, and use a clear step-by-step routine so the resident is not overwhelmed.`,
      },
    },
    {
      id: `${id}_intervention_choices`,
      label: "Offer simple choices and reminders",
      description: "Use when decision-making or memory affects independence.",
      groupLabel: "Caregiver interventions",
      updates: {
        [assistanceField]: `Caregivers should offer simple choices, reminders, and cueing related to ${interventionContext} when memory, judgment, or attention affects independent follow-through.`,
      },
    },
    {
      id: `${id}_intervention_coordinate`,
      label: "Coordinate with outside supports when needed",
      description: "Important when the resident depends on family, case managers, or scheduled services.",
      groupLabel: "Caregiver interventions",
      updates: {
        [assistanceField]: `Caregivers should coordinate with family, authorized contacts, transportation, or outside supports related to ${interventionContext} when the resident cannot manage the task safely alone.`,
      },
    },
    {
      id: `${id}_intervention_report`,
      label: "Report decline, missed follow-through, or new barriers",
      description: "Use when support needs appear to be increasing.",
      groupLabel: "Caregiver interventions",
      updates: {
        [assistanceField]: `Caregivers should report decline from baseline, missed follow-through, new barriers, or increasing assistance needs related to ${interventionContext} so the support plan can be updated.`,
      },
    },
  ],
});

export const IADL_GENIE_QUESTIONS: CarePlanGenieQuestion[] = [
  iadlLevelQuestion(
    "finance",
    "Managing Finances",
    "What best describes the resident's ability to manage finances?",
    "manageFinanceLevel",
    "manageFinanceDetails",
    "manageFinanceAssistanceRequired",
    "managing money, bills, and financial decisions",
    "finance support and financial decision-making",
  ),
  {
    id: "finance_supports",
    title: "Finance Supports",
    prompt: "What finance oversight, payee, or record-management details should be documented?",
    helperText: "Choose the financial support details that apply and the caregiver steps that should happen consistently.",
    editableFieldKeys: [
      "anyWhoManagesFinanceDetails",
      "anyWhoManagesFinanceAssistanceRequired",
      "anyWhoManagesFinancialRecordsDetails",
      "anyWhoManagesFinancialRecordsAssistanceRequired",
      "payeeDetails",
    ],
    options: [
      {
        id: "finance_manager",
        label: "Another person manages finances",
        description: "Family, guardian, payee, or another support person handles money matters.",
        groupLabel: "IADL details",
        updates: {
          anyWhoManagesFinance: true,
          anyWhoManagesFinanceDetails: "Another responsible person manages the resident's finances, spending decisions, or bill-related tasks.",
        },
      },
      {
        id: "finance_records",
        label: "Financial records or paperwork are managed by others",
        description: "Statements, receipts, or documentation need oversight.",
        groupLabel: "IADL details",
        updates: {
          anyWhoManagesFinancialRecords: true,
          anyWhoManagesFinancialRecordsDetails: "Financial records, account paperwork, or bill-related documents are maintained or overseen by another responsible person.",
        },
      },
      {
        id: "finance_payee",
        label: "Payee or representative payee details should be listed",
        description: "Use when benefit or income oversight is part of the plan.",
        groupLabel: "IADL details",
        updates: {
          anyPayeeDetails: true,
          payeeDetails: "Document the resident's payee or representative payee information and any limits on independent financial access here.",
        },
      },
      {
        id: "finance_intervention",
        label: "Coordinate with the responsible financial contact",
        description: "Caregivers should know who to reach when money-related issues come up.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyWhoManagesFinance: true,
          anyWhoManagesFinanceAssistanceRequired: "Caregivers should coordinate with the person responsible for finances when purchases, bill questions, benefit issues, or resident requests need review.",
        },
      },
      {
        id: "finance_records_intervention",
        label: "Protect paperwork and report concerns",
        description: "Important when the resident misplaces, signs, or misunderstands records.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyWhoManagesFinancialRecords: true,
          anyWhoManagesFinancialRecordsAssistanceRequired: "Caregivers should protect financial paperwork, route questions to the appropriate contact, and report concerns about confusion, requests, or possible vulnerability.",
        },
      },
    ],
  },
  iadlLevelQuestion(
    "shopping",
    "Shopping",
    "What best describes the resident's ability to manage shopping needs?",
    "manageShoppingLevel",
    "manageShoppingDetails",
    "manageShoppingAssistanceRequired",
    "shopping, selecting needed items, and managing errands",
    "shopping support and purchase planning",
  ),
  {
    id: "shopping_supports",
    title: "Shopping Supports",
    prompt: "What shopping transportation, equipment, or limitation details should be documented?",
    helperText: "Choose shopping details and the caregiver support steps that should happen consistently.",
    editableFieldKeys: [
      "specialShoppingTransportationDetails",
      "specialShoppingTransportationAssistanceRequired",
      "shoppingEquipmentDetails",
      "shoppingEquipmentAssistanceRequired",
      "shoppingLimitationsDetails",
      "shoppingLimitationsAssistanceRequired",
      "shoppingFrequencyDetails",
      "shoppingFrequencyAssistanceRequired",
    ],
    options: [
      {
        id: "shopping_transport",
        label: "Needs transportation support for shopping",
        description: "Errands depend on rides, escorts, or planned outings.",
        groupLabel: "IADL details",
        updates: {
          specialShoppingTransportationNeeds: true,
          specialShoppingTransportationDetails: "Shopping needs depend on transportation support, planned outings, caregiver assistance, or help coordinating errands.",
        },
      },
      {
        id: "shopping_equipment",
        label: "Uses shopping equipment or physical supports",
        description: "Cart support, wheelchair access, or other physical needs affect shopping.",
        groupLabel: "IADL details",
        updates: {
          anyShoppingEquipmentNeeds: true,
          shoppingEquipmentDetails: "Shopping may require equipment, mobility supports, carrying help, or environmental access accommodations.",
        },
      },
      {
        id: "shopping_limits",
        label: "Has cognitive or physical shopping limitations",
        description: "Endurance, judgment, memory, or safety affects participation.",
        groupLabel: "IADL details",
        updates: {
          anyShoppingLimitations: true,
          shoppingLimitationsDetails: "Shopping may be limited by fatigue, mobility, judgment, memory, safety awareness, sensory overload, or difficulty managing choices in stores.",
        },
      },
      {
        id: "shopping_frequency",
        label: "Shopping schedule or frequency should be noted",
        description: "Use when recurring support is part of the plan.",
        groupLabel: "IADL details",
        updates: {
          shoppingFrequencyDetails: "Resident benefits from a planned shopping routine or caregiver-managed schedule for groceries, personal items, and supply follow-up.",
        },
      },
      {
        id: "shopping_intervention",
        label: "Plan outings, lists, and needed items ahead of time",
        description: "Caregivers should prepare so shopping remains safe and efficient.",
        groupLabel: "Caregiver interventions",
        updates: {
          manageShoppingAssistanceRequired: "Caregivers should help plan shopping needs, prepare lists, manage timing, and support purchases based on the resident's preferences, budget, and safety needs.",
        },
      },
      {
        id: "shopping_transport_intervention",
        label: "Coordinate rides and physical assistance",
        description: "Important when shopping depends on transport or escort help.",
        groupLabel: "Caregiver interventions",
        updates: {
          specialShoppingTransportationNeeds: true,
          specialShoppingTransportationAssistanceRequired: "Caregivers should coordinate rides, escort support, and loading or carrying help when the resident cannot safely manage shopping transportation alone.",
        },
      },
    ],
  },
  iadlLevelQuestion(
    "transportation",
    "Transportation",
    "What best describes the resident's transportation level?",
    "transportationManageLevel",
    "transportationManageDetails",
    "transportationManageAssistanceRequired",
    "transportation planning, rides, and travel support",
    "transportation support and ride coordination",
  ),
  {
    id: "transportation_supports",
    title: "Transportation Supports",
    prompt: "What special transportation, escort, medical, equipment, or limitation details should be documented?",
    helperText: "Choose transportation details and the caregiver steps that should happen consistently.",
    editableFieldKeys: [
      "specialTransportationDetails",
      "specialTransportationAssistanceRequired",
      "transportationMedicalDetails",
      "transportationMedicalAssistanceRequired",
      "transportationEscortDetails",
      "transportationEscortAssistanceRequired",
      "transportationEquipmentDetails",
      "transportationEquipmentAssistanceRequired",
      "transportationLimitationsDetails",
      "transportationLimitationsAssistanceRequired",
    ],
    options: [
      {
        id: "transport_special",
        label: "Needs special transportation arrangements",
        description: "Medical transport, scheduled rides, or adapted transport are part of care.",
        groupLabel: "IADL details",
        updates: {
          specialTransportationNeeds: true,
          specialTransportationDetails: "Resident needs planned transportation arrangements, adapted transport, or caregiver coordination for appointments and community access.",
        },
      },
      {
        id: "transport_medical",
        label: "Medical condition affects transport",
        description: "Symptoms, oxygen, fatigue, or treatment needs change how rides happen.",
        groupLabel: "IADL details",
        updates: {
          anyTransportationMedicalNeeds: true,
          transportationMedicalDetails: "Transportation planning should consider medical symptoms, mobility status, oxygen or equipment use, endurance, timing, or treatment-related needs.",
        },
      },
      {
        id: "transport_escort",
        label: "Needs an escort or direct support during transport",
        description: "The resident should not travel independently.",
        groupLabel: "IADL details",
        updates: {
          anyTransportationEscortNeeds: true,
          transportationEscortDetails: "Resident needs escort support, supervision, or direct caregiver involvement during transportation for safety and follow-through.",
        },
      },
      {
        id: "transport_equipment",
        label: "Uses transportation-related equipment or setup",
        description: "Mobility devices or transfer supports affect transport planning.",
        groupLabel: "IADL details",
        updates: {
          anyTransportationEquipmentNeeds: true,
          transportationEquipmentDetails: "Transportation requires mobility equipment, transfer setup, secure loading, or other travel-related physical supports.",
        },
      },
      {
        id: "transport_limits",
        label: "Has transportation limitations",
        description: "Cognition, endurance, behavior, or anxiety affect travel.",
        groupLabel: "IADL details",
        updates: {
          anyTransportationLimitations: true,
          transportationLimitationsDetails: "Transportation may be limited by endurance, confusion, anxiety, behavior, pain, mobility changes, or reduced tolerance for long outings.",
        },
      },
      {
        id: "transport_intervention_plan",
        label: "Plan rides and timing around the resident's condition",
        description: "Caregivers should match transportation support to daily needs.",
        groupLabel: "Caregiver interventions",
        updates: {
          transportationManageAssistanceRequired: "Caregivers should plan rides in advance, adjust transportation support to the resident's condition, and coordinate timing around appointments, fatigue, and tolerance.",
        },
      },
      {
        id: "transport_intervention_escort",
        label: "Provide escort and safety oversight",
        description: "Use when the resident needs supervision during travel.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyTransportationEscortNeeds: true,
          transportationEscortAssistanceRequired: "Caregivers should provide escort support, help with transitions in and out of transport, and maintain supervision when the resident cannot travel safely alone.",
        },
      },
    ],
  },
  iadlLevelQuestion(
    "activities_social",
    "Activities and Social Engagement",
    "What best describes the resident's activity and social participation level?",
    "activityLevel",
    "activityDetails",
    "activityAssistanceRequired",
    "daily activity participation and social engagement",
    "activity planning and social engagement support",
  ),
  {
    id: "activities_supports",
    title: "Activity and Relationship Supports",
    prompt: "What social, family, participation, or preferred-activity details should be documented?",
    helperText: "Choose engagement details and the caregiver steps that help the resident participate more successfully.",
    editableFieldKeys: [
      "religiousActivitiesDetails",
      "religiousActivitiesAssistanceRequired",
      "socialCulturalActivitiesDetails",
      "socialCulturalActivitiesAssistanceRequired",
      "familyFriendsRelationshipsDetails",
      "familyFriendsRelationshipsAssistanceRequired",
      "participationIssuesDetails",
      "participationIssuesAssistanceRequired",
      "activityNarrative",
    ],
    options: [
      {
        id: "activities_religious",
        label: "Religious or spiritual activities matter",
        description: "Faith-based routine, church, or spiritual support is meaningful.",
        groupLabel: "IADL details",
        updates: {
          anyReligiousActivities: true,
          religiousActivitiesDetails: "Resident benefits from religious or spiritual activities that support comfort, routine, identity, or community connection.",
        },
      },
      {
        id: "activities_social",
        label: "Social or cultural activities should be encouraged",
        description: "The resident benefits from structured social engagement.",
        groupLabel: "IADL details",
        updates: {
          anySocialCulturalActivities: true,
          socialCulturalActivitiesDetails: "Resident benefits from social or cultural activities that support engagement, enjoyment, structure, and connection with others.",
        },
      },
      {
        id: "activities_family",
        label: "Family and friend relationships are important supports",
        description: "Contact with familiar people affects wellbeing.",
        groupLabel: "IADL details",
        updates: {
          anyFamilyFriendsRelationships: true,
          familyFriendsRelationshipsDetails: "Family and friend contact is meaningful to the resident and should be considered in the ongoing activity and support plan.",
        },
      },
      {
        id: "activities_barriers",
        label: "Participation barriers should be documented",
        description: "Fatigue, behavior, mobility, cognition, or mood affect involvement.",
        groupLabel: "IADL details",
        updates: {
          anyParticipationIssues: true,
          participationIssuesDetails: "Participation may be limited by fatigue, mood, cognition, mobility, sensory needs, behavior, transportation access, or reduced tolerance for groups or outings.",
        },
      },
      {
        id: "activities_glance",
        label: "Use common favorite activities as engagement anchors",
        description: "Helpful when the resident does best with familiar interests.",
        groupLabel: "IADL details",
        updates: {
          activitiesAtGlance: activitiesAtGlanceValues,
          activityNarrative: "Use familiar interests and preferred routines to support regular participation, enjoyment, and redirection when needed.",
        },
      },
      {
        id: "activities_intervention_choices",
        label: "Offer simple choices and plan familiar routines",
        description: "Caregivers should use activities intentionally, not randomly.",
        groupLabel: "Caregiver interventions",
        updates: {
          activityAssistanceRequired: "Caregivers should offer simple activity choices, plan familiar routines, and adapt participation to the resident's energy, mood, cognition, and interests.",
        },
      },
      {
        id: "activities_intervention_relationships",
        label: "Support contact with important people",
        description: "Use when relationships improve mood or participation.",
        groupLabel: "Caregiver interventions",
        updates: {
          anyFamilyFriendsRelationships: true,
          familyFriendsRelationshipsAssistanceRequired: "Caregivers should help maintain contact with important family or friends, share relevant updates when appropriate, and support participation in meaningful social routines.",
        },
      },
    ],
  },
  {
    id: "smoking",
    title: "Smoking",
    prompt: "What smoking-related details and safety supports should be documented?",
    helperText: "Choose smoking details and the caregiver safety steps that should happen consistently.",
    editableFieldKeys: [
      "smokingDetails",
      "smokingAssistanceRequired",
      "smokingSafetyConcernsDetails",
      "smokingSafetyConcernsAssistanceRequired",
      "smokingPolicySignedDetails",
      "smokingStorageDetails",
    ],
    options: [
      {
        id: "smoking_present",
        label: "Resident smokes",
        description: "Smoking routine, supervision, or storage should be addressed clearly.",
        groupLabel: "IADL details",
        updates: {
          doesSmoke: true,
          smokingDetails: "Resident smokes or uses smoking-related items and needs a clear routine that addresses frequency, supervision, storage, and safe location use.",
        },
      },
      {
        id: "smoking_safety",
        label: "Smoking safety concerns are present",
        description: "Cognition, oxygen, burns, mobility, or supervision issues affect safety.",
        groupLabel: "IADL details",
        updates: {
          anySmokingSafetyConcerns: true,
          smokingSafetyConcernsDetails: "Smoking safety may be affected by cognition, judgment, oxygen use, fall risk, tremors, fatigue, burns, or the need for a supervised smoking area.",
        },
      },
      {
        id: "smoking_policy",
        label: "Smoking policy or agreement should be documented",
        description: "Use when the resident has signed or should follow a smoking policy.",
        groupLabel: "IADL details",
        updates: {
          anySmokingPolicySigned: true,
          smokingPolicySignedDetails: "Document the resident's smoking policy, agreement, or house rules related to smoking location, timing, and safety expectations.",
        },
      },
      {
        id: "smoking_storage",
        label: "Storage of smoking items should be addressed",
        description: "Lighters, cigarettes, or materials need a clear plan.",
        groupLabel: "IADL details",
        updates: {
          smokingStorageDetails: "Document where cigarettes, vaping supplies, lighters, or related items are stored and how access is managed safely.",
        },
      },
      {
        id: "smoking_intervention",
        label: "Use a supervised and consistent smoking routine",
        description: "Caregivers should follow the same safety plan every time.",
        groupLabel: "Caregiver interventions",
        updates: {
          doesSmoke: true,
          smokingAssistanceRequired: "Caregivers should follow a consistent smoking routine, supervise as needed, reinforce safe location use, and provide reminders based on the resident's cognitive and physical safety needs.",
        },
      },
      {
        id: "smoking_intervention_safety",
        label: "Watch for fire, burn, and unsafe-use risks",
        description: "Use when smoking creates clear safety concerns.",
        groupLabel: "Caregiver interventions",
        updates: {
          anySmokingSafetyConcerns: true,
          smokingSafetyConcernsAssistanceRequired: "Caregivers should monitor for fire risk, burns, impaired judgment, unsafe smoking behaviors, or conflicts with oxygen and follow the safety plan without exception.",
        },
      },
    ],
  },
  {
    id: "case_management",
    title: "Case Management",
    prompt: "What case-management support and contact details should be documented?",
    helperText: "Choose case-management details and the caregiver follow-through steps that should happen consistently.",
    editableFieldKeys: [
      "caseManagementDetails",
      "caseManagementAssistanceRequired",
      "conditionsWhenToContactCaseManager",
      "caseManagerContactName",
      "caseManagerContactAgency",
      "caseManagerContactPhone",
    ],
    options: [
      {
        id: "case_management_active",
        label: "Resident receives case management",
        description: "A case manager or outside coordinator is part of the support plan.",
        groupLabel: "IADL details",
        updates: {
          receivesCaseManagement: true,
          caseManagementDetails: "Resident receives case management or outside coordination support that should be reflected in the care plan.",
        },
      },
      {
        id: "case_management_contact",
        label: "Case manager contact details should stay current",
        description: "Name, agency, and phone should be easy for caregiver to find.",
        groupLabel: "IADL details",
        updates: {
          receivesCaseManagement: true,
          caseManagerContactName: "Keep case manager name current",
          caseManagerContactAgency: "Keep case manager agency current",
          caseManagerContactPhone: "Keep case manager phone current",
        },
      },
      {
        id: "case_management_conditions",
        label: "Conditions for contacting the case manager should be listed",
        description: "Use when caregiver need clear escalation guidance.",
        groupLabel: "IADL details",
        updates: {
          receivesCaseManagement: true,
          conditionsWhenToContactCaseManager: "Document when the case manager should be contacted for changes in condition, discharge planning, service issues, safety concerns, or unmet support needs.",
        },
      },
      {
        id: "case_management_intervention",
        label: "Coordinate updates and service concerns with the case manager",
        description: "Caregivers should know when and how to communicate changes.",
        groupLabel: "Caregiver interventions",
        updates: {
          receivesCaseManagement: true,
          caseManagementAssistanceRequired: "Caregivers should share relevant updates with the case manager, report service concerns, and notify the appropriate contact when the resident's needs or situation changes.",
        },
      },
    ],
  },
  {
    id: "other_issues",
    title: "Other Issues",
    prompt: "What other instrumental daily-living issues or concerns should be documented?",
    helperText: "Choose details and the caregiver steps that should happen consistently.",
    editableFieldKeys: ["additionalInformation", "additionalInformationAssistanceRequired"],
    options: [
      {
        id: "other_issues_general",
        label: "Other IADL concerns should be listed",
        description: "Use when there are daily-living issues not fully captured elsewhere in the section.",
        groupLabel: "IADL details",
        updates: {
          additionalInformation: "Resident has additional instrumental daily-living concerns or support needs that should be documented here for caregiver awareness and consistency.",
        },
      },
      {
        id: "other_issues_variability",
        label: "Ability varies depending on health, mood, or cognition",
        description: "Useful when support changes from day to day.",
        groupLabel: "IADL details",
        updates: {
          additionalInformation: "Support needs may vary based on health status, cognition, mood, fatigue, appointments, or environmental stressors and should be reassessed as needed.",
        },
      },
      {
        id: "other_issues_intervention",
        label: "Use individualized support and communicate changes",
        description: "Caregivers should adapt consistently and keep the team updated.",
        groupLabel: "Caregiver interventions",
        updates: {
          additionalInformationAssistanceRequired: "Caregivers should use individualized support strategies, document changes in daily-living ability, and share updates when the resident's IADL support needs increase or shift.",
        },
      },
    ],
  },
];

export const buildInstrumentalActivitiesGeniePreview = (
  currentValues: Record<string, any>,
  selectedOptions: Record<string, string[]>,
  questionDrafts: Record<string, Record<string, string>>,
) => buildCarePlanGeniePreview(
  IADL_GENIE_FIELD_DEFINITIONS,
  IADL_GENIE_QUESTIONS,
  currentValues,
  selectedOptions,
  questionDrafts,
);
